import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_horizontal_menu = _resolveComponent("top-horizontal-menu");
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['main-page', !_ctx.isMobile ? 'is-desktop' : ''])
  }, [_createVNode(_component_top_horizontal_menu), _createElementVNode("div", {
    class: _normalizeClass(['main-page-content', _ctx.isFullScreen ? 'is-full-screen' : ''])
  }, [_createVNode(_component_router_view)], 2)], 2);
}